import { Flex } from "@chakra-ui/react"

import Header from "../Header"
import NavMenu from "../NavMenu"
import { useSelector } from "react-redux"
import { State } from "state/reducers"

import background from 'assets/images/background.png'

import LoadMe from "components/LoadMe"
import { useMe } from "hooks/useAuth"

interface Props {
    children: React.ReactNode | React.ReactNode[]
    withBackground?: boolean
}

const ManagerLayout = ({ children, withBackground = false }: Props) => {
    const { id } = useSelector(({ auth }: State) => auth)
    const navBar = useSelector(({ navBar }: State) => navBar)

    const backgroundProprieties = !withBackground ? {}
    : {
        backgroundImage: background,
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
    }

    if (id === null || id === '') return <LoadMe />
    return (
        <Flex
            w="full"
            minH="100vh"
            flexDirection="column"
            justifyContent="flex-start"
            pt="80px"
            pb="40px"
            pl={navBar ? "96px" : "258px"}
            pr="20px"
            alignItems="flex-start"
            transition="all ease 0.25s"
            {...backgroundProprieties}
        >
            <NavMenu />
            <Header />
            {children}
        </Flex>
    )
}

export default ManagerLayout